
import { COLORS } from '../../config/designSystem/Colors';
import { EvolunoCheck } from '../../assets/images/Icons/Check/EvolunoCheck';
import { ParagraphMRegular } from '../../config/designSystem/typography';
import { View } from 'react-native';

export const Contacted = ( {label }: {label: string}) => {

  return(<View

    style={{position:'absolute',  paddingHorizontal: 10, paddingVertical: 5, flexDirection: 'row',
      borderRadius: 10,right: 10, top: 20, zIndex:2, backgroundColor:'white', columnGap:10}}>
    <EvolunoCheck color={COLORS.state.success.primary} size={20}/>
    <ParagraphMRegular color={COLORS.state.success.primary}>{label}
    </ParagraphMRegular>
  </View>);

};